export const jiraPrefillFields = [
  { label: 'User ID', value: '{{user.id}}' },
  { label: 'Issue Key', value: '{{issue.key}}' },
  { label: 'Issue Summary', value: '{{issue.summary}}' },
  { label: 'Issue Type', value: '{{issue.type}}' },
  { label: 'Issue URL', value: '{{issue.url}}' },
  { label: 'Project Key', value: '{{project.key}}' },
  { label: 'Project Name', value: '{{project.name}}' },
  { label: 'Project URL', value: '{{project.url}}' },
]

export const selectIconSize = [
  { label: 'Small', value: 'small' },
  { label: 'Medium', value: 'medium' },
  { label: 'Large', value: 'large' },
  { label: 'XLarge', value: 'xlarge' },
]

export const selectFeatures = [
  { label: 'Active', value: 'active' },
  { label: 'Border', value: 'border' },
  { label: 'Branded', value: 'branded' },
  { label: 'Fullscreen', value: 'fullscreen' },
  { label: 'Hover', value: 'hover' },
  { label: 'Icons', value: 'icons' },
  { label: 'Indicator', value: 'indicator' },
  { label: 'Rounded', value: 'rounded' },
  { label: 'Ripples', value: 'ripples' },
  { label: 'Separator', value: 'separator' },
  { label: 'Titles', value: 'titles' },
]

export const selectType = [
  { label: 'Centered', value: 'centered' },
  { label: 'Scrollable', value: 'scrollable' },
  { label: 'Stretched', value: 'fullWidth' },
]

export const fonts = [
  {
    label: 'Arial',
    value: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
  },
  {
    label: 'Arial Black',
    value: '"Arial Black", "Arial Bold", Gadget, sans-serif',
  },
  {
    label: 'Arial Narrow',
    value: '"Arial Narrow", Arial, sans-serif',
  },
  {
    label: 'Arial Rounded',
    value: '"Arial Rounded MT Bold", "Helvetica Rounded", Arial, sans-serif',
  },
  {
    label: 'Atlassian',
    value:
      '"Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
  {
    label: 'Avant Garde',
    value:
      '"Avant Garde", Avantgarde, "Century Gothic", CenturyGothic, AppleGothic, sans-serif',
  },
  {
    label: 'Calibri',
    value: 'Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif',
  },
  {
    label: 'Candara',
    value: 'Candara, Calibri, Segoe, "Segoe UI", Optima, Arial, sans-serif',
  },
  {
    label: 'Century Gothic',
    value: '"Century Gothic", CenturyGothic, AppleGothic, sans-serif',
  },
  {
    label: 'Franklin Gothic',
    value:
      '"Franklin Gothic Medium", "Franklin Gothic", "ITC Franklin Gothic", Arial, sans-serif',
  },
  {
    label: 'Futura',
    value: 'Futura, "Trebuchet MS", Arial, sans-serif',
  },
  {
    label: 'Geneva',
    value: 'Geneva, Tahoma, Verdana, sans-seri',
  },
  {
    label: 'Gill Sans',
    value: '"Gill Sans", "Gill Sans MT", Calibri, sans-serif',
  },
  {
    label: 'Helvetica',
    value: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  },
  {
    label: 'Impact',
    value:
      'Impact, Haettenschweiler, "Franklin Gothic Bold", Charcoal, "Helvetica Inserat", "Bitstream Vera Sans Bold", "Arial Black", "sans serif"',
  },
  {
    label: 'Lucida Grande',
    value:
      '"Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva, Verdana, sans-serif',
  },
  {
    label: 'Optima',
    value: 'Optima, Segoe, "Segoe UI", Candara, Calibri, Arial, sans-serif',
  },
  {
    label: 'Segoe UI',
    value:
      '"Segoe UI", Frutiger, "Frutiger Linotype", "Dejavu Sans", "Helvetica Neue", Arial, sans-serif',
  },
  {
    label: 'Tahoma',
    value: 'Tahoma, Verdana, Segoe, sans-serif',
  },
  {
    label: 'Trebuchet MS',
    value:
      '"Trebuchet MS", "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Tahoma, sans-serif',
  },
  {
    label: 'Verdana',
    value: 'Verdana, Geneva, sans-serif',
  },
]

// IF CHANGING OBJECT KEYS HERE YOU NEED TO UPDATE THE CLOUDFLARE WORKER STORING USER THEMES
export const themes = (isJira = false) => [
  {
    theme: 'Atlas White',
    features: [
      'titles',
      'rounded',
      'border',
      'branded',
      'indicator',
      'active',
      'icons',
      'fullscreen',
    ],
    padding: isJira ? 6 : 10,
    height: isJira ? 500 : 600,
    tabFont: 'Atlassian',
    tabSize: isJira ? 14 : 15,
    tabBold: true,
    tabItalic: false,
    tabUnderline: false,
    tabColor: '#172b4d',
    tabColorBG: '#ffffff',
    type: 'scrollable',
    opacity: 100,
    activeColor: '#0052cc',
    activeColorBG: '#ffffff',
    borderWidth: 1,
    borderColor: '#ebecf0',
    radius: 5,
    hoverColor: '#ffffff',
    hoverColorBG: '#0052cc',
    iconSize: 'medium',
    iconInline: true,
    iconPrimary: '#0052cc',
    iconSecondary: '#ffffff',
    separatorWidth: 1,
    separatorColor: '#42526E',
    indicatorPercent: 5,
    indicatorColor: '#0052cc',
    indicatorColorBG: '#ebecf0',
    hide: false,
    vertical: false,
    preload: true,
    animate: false,
  },
  {
    theme: 'Clean Lines',
    features: [
      'titles',
      'border',
      'rounded',
      'ripples',
      'separator',
      'active',
      'icons',
      'fullscreen',
    ],
    padding: isJira ? 6 : 10,
    height: isJira ? 500 : 600,
    tabFont: 'Atlassian',
    tabSize: isJira ? 14 : 15,
    tabBold: true,
    tabItalic: false,
    tabUnderline: false,
    tabColor: '#172b4d',
    tabColorBG: '#ffffff',
    type: 'scrollable',
    opacity: 95,
    activeColor: '#ffffff',
    activeColorBG: '#0747a6',
    borderWidth: 1,
    borderColor: '#ebecf0',
    radius: 5,
    hoverColor: '#ffffff',
    hoverColorBG: '#0052cc',
    iconSize: 'medium',
    iconInline: true,
    iconPrimary: '#2684ff',
    iconSecondary: '#ffffff',
    separatorWidth: 1,
    separatorColor: '#ebecf0',
    indicatorPercent: 5,
    indicatorColor: '#ff5630',
    indicatorColorBG: '#0052cc',
    hide: false,
    vertical: false,
    preload: true,
    animate: false,
  },
  {
    theme: 'Dark Moon',
    features: [
      'titles',
      'active',
      'border',
      'rounded',
      'icons',
      'ripples',
      'hover',
      'separator',
      'fullscreen',
    ],
    padding: isJira ? 6 : 10,
    height: isJira ? 500 : 600,
    tabFont: 'Atlassian',
    tabSize: isJira ? 14 : 15,
    tabBold: true,
    tabItalic: false,
    tabUnderline: false,
    tabColor: '#1da1f2',
    tabColorBG: '#15202b',
    type: 'scrollable',
    opacity: 95,
    activeColor: '#ffffff',
    activeColorBG: '#192734',
    borderWidth: 1,
    borderColor: '#ebecf0',
    radius: 5,
    hoverColor: '#1da1f2',
    hoverColorBG: '#192734',
    iconSize: 'medium',
    iconInline: true,
    iconPrimary: '#ffffff',
    iconSecondary: '#172b4d',
    separatorWidth: 1,
    separatorColor: '#253341',
    indicatorPercent: 5,
    indicatorColor: '#ff5630',
    indicatorColorBG: '#0052cc',
    hide: false,
    vertical: false,
    preload: true,
    animate: false,
  },
  {
    theme: 'Electric Blue',
    features: [
      'titles',
      'active',
      'border',
      'rounded',
      'icons',
      'ripples',
      'fullscreen',
    ],
    padding: isJira ? 6 : 10,
    height: isJira ? 500 : 600,
    tabFont: 'Atlassian',
    tabSize: isJira ? 14 : 15,
    tabBold: true,
    tabItalic: false,
    tabUnderline: false,
    tabColor: '#ffffff',
    tabColorBG: '#172b4d',
    type: 'scrollable',
    opacity: 100,
    activeColor: '#ffffff',
    activeColorBG: '#0052cc',
    borderWidth: 1,
    borderColor: '#ebecf0',
    radius: 5,
    hoverColor: '#ffffff',
    hoverColorBG: '#0052cc',
    iconSize: 'medium',
    iconInline: true,
    iconPrimary: '#ffffff',
    iconSecondary: '#172b4d',
    separatorWidth: 1,
    separatorColor: '#42526E',
    indicatorPercent: 5,
    indicatorColor: '#ff5630',
    indicatorColorBG: '#0052cc',
    hide: false,
    vertical: false,
    preload: true,
    animate: false,
  },
  {
    theme: 'Midnight Blue',
    features: [
      'titles',
      'rounded',
      'border',
      'indicator',
      'active',
      'icons',
      'fullscreen',
    ],
    padding: isJira ? 6 : 10,
    height: isJira ? 500 : 600,
    tabFont: 'Atlassian',
    tabSize: isJira ? 14 : 15,
    tabBold: true,
    tabItalic: false,
    tabUnderline: false,
    tabColor: '#ffffff',
    tabColorBG: '#2e1534',
    type: 'scrollable',
    opacity: 70,
    activeColor: '#ffffff',
    activeColorBG: '#635ee7',
    borderWidth: 1,
    borderColor: '#ebecf0',
    radius: 5,
    hoverColor: '#635ee7',
    hoverColorBG: '#2e1534',
    iconSize: 'medium',
    iconInline: true,
    iconPrimary: '#ffffff',
    iconSecondary: '#172b4d',
    separatorWidth: 1,
    separatorColor: '#42526E',
    indicatorPercent: 5,
    indicatorColor: '#635ee7',
    indicatorColorBG: '#635ee7',
    hide: false,
    vertical: false,
    preload: true,
    animate: true,
  },
  {
    theme: 'Rocket Orange',
    features: [
      'titles',
      'border',
      'rounded',
      'indicator',
      'icons',
      'fullscreen',
    ],
    padding: isJira ? 6 : 10,
    height: isJira ? 500 : 600,
    tabFont: 'Atlassian',
    tabSize: isJira ? 14 : 15,
    tabBold: true,
    tabItalic: false,
    tabUnderline: false,
    tabColor: '#ffffff',
    tabColorBG: '#172b4d',
    type: 'scrollable',
    opacity: 100,
    activeColor: '#ffffff',
    activeColorBG: '#0052cc',
    borderWidth: 1,
    borderColor: '#ebecf0',
    radius: 5,
    hoverColor: '#ffffff',
    hoverColorBG: '#0052cc',
    iconSize: 'medium',
    iconInline: true,
    iconPrimary: '#ffffff',
    iconSecondary: '#172b4d',
    separatorWidth: 1,
    separatorColor: '#42526E',
    indicatorPercent: 100,
    indicatorColor: '#ff5630',
    indicatorColorBG: '#172b4d',
    hide: false,
    vertical: false,
    preload: true,
    animate: false,
  },
  {
    theme: 'Summer Pink',
    features: [
      'titles',
      'rounded',
      'border',
      'indicator',
      'icons',
      'fullscreen',
    ],
    padding: isJira ? 6 : 10,
    height: isJira ? 500 : 600,
    tabFont: 'Atlassian',
    tabSize: isJira ? 14 : 15,
    tabBold: true,
    tabItalic: false,
    tabUnderline: false,
    tabColor: '#ffffff',
    tabColorBG: '#ff2989',
    type: 'scrollable',
    opacity: 100,
    activeColor: '#ffffff',
    activeColorBG: '#0052cc',
    borderWidth: 1,
    borderColor: '#ebecf0',
    radius: 5,
    hoverColor: '#ffffff',
    hoverColorBG: '#0052cc',
    iconSize: 'medium',
    iconInline: true,
    iconPrimary: '#ffffff',
    iconSecondary: '#172b4d',
    separatorWidth: 1,
    separatorColor: '#42526E',
    indicatorPercent: 5,
    indicatorColor: '#96ff26',
    indicatorColorBG: '#ffb96e',
    hide: false,
    vertical: false,
    preload: true,
    animate: true,
  },
]
